/* Home animations ported from the custom site. Only transform and opacity are animated. */
(function () {
	if (!window.gsap || !window.ScrollTrigger) return;
	var designMode = window.Shopify && Shopify.designMode;
	if (designMode || matchMedia('(prefers-reduced-motion: reduce)').matches) return;

	gsap.registerPlugin(ScrollTrigger);

	function pad(value, length) { return String(value).padStart(length, '0'); }
	function dms(value, pos, neg) {
		var tenths = Math.round(Math.abs(value) * 36000);
		var d = Math.floor(tenths / 36000), m = Math.floor((tenths % 36000) / 600), s = (tenths % 600) / 10;
		return d + '°' + pad(m, 2) + '′' + s.toFixed(1).padStart(4, '0') + '″ ' + (value < 0 ? neg : pos);
	}
	function coords(lat, lng) { return dms(lat, 'N', 'S') + ' · ' + dms(lng, 'E', 'W'); }

	// Words rise out of their masks; the heading keeps its text for screen readers.
	function split(el) {
		var text = el.textContent.trim();
		el.setAttribute('aria-label', text);
		el.innerHTML = text.split(/\s+/).map(function (word) {
			return '<span class="gc-word-mask" aria-hidden="true"><span class="gc-word" data-word>' + word + '</span></span>';
		}).join(' ');
	}

	var story = document.querySelector('[data-gc-story]');
	if (story) {
		var title = story.querySelector('[data-gc-split]');
		if (title) split(title);

		var intro = gsap.timeline({ defaults: { ease: 'expo.out' } });
		intro.from(story.querySelectorAll('[data-word]'), { yPercent: 110, duration: 1.2, stagger: 0.06 })
			.from(story.querySelector('.gc-hero__img'), { scale: 1.18, duration: 1.8 }, 0)
			.from(story.querySelectorAll('[data-fade]'), { y: 24, stagger: 0.08, duration: 0.9 }, 0.45);

		var label = story.querySelector('[data-coords]');
		if (label) {
			// New text means new layout: a dozen updates a second look the same as sixty and cost far less.
			var position = { lat: 0, lng: 0 }, shown = 0;
			intro.to(position, {
				lat: 35.0116, lng: 135.7681, duration: 2, ease: 'power4.out',
				onUpdate: function () {
					var now = performance.now();
					if (now - shown < 80 && this.progress() < 1) return;
					shown = now;
					label.textContent = coords(position.lat, position.lng);
				},
			}, 0.3);
		}
	}

	// Sticky panels instead of GSAP pins: from 990px Horizon scrolls .page-wrapper, and a fixed panel
	// would stop the wheel from reaching it. Each panel's section gets the height of its scroll length.
	function scrolling(scroller) {
		if (chapters.length) {
			var timeline = gsap.timeline({
				defaults: { ease: 'none' },
				scrollTrigger: {
					trigger: story.parentElement,
					scroller: scroller,
					start: 'top top',
					end: 'bottom bottom',
					scrub: 0.8,
					snap: { snapTo: 1 / (chapters.length - 1), duration: { min: 0.2, max: 0.6 }, ease: 'power2.inOut' },
				},
			});
			chapters.forEach(function (chapter, i) {
				var img = chapter.querySelector('img');
				var copy = chapter.querySelectorAll('[data-copy]');
				if (i > 0) {
					timeline.fromTo(chapter, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.3 }, i - 0.3)
						.from(copy, { yPercent: 40, opacity: 0, stagger: 0.05, duration: 0.3 }, i - 0.2);
				}
				if (i === 0) timeline.to(img, { scale: 1.1, duration: 1 }, 0);
				else timeline.fromTo(img, { scale: 1.15 }, { scale: 1, duration: 1.3 }, i - 0.3);
			});
			timeline.fromTo(story.querySelector('[data-story-bar]'), { scaleX: 0 }, { scaleX: 1, duration: chapters.length - 1 }, 0);
		}

		var tiers = document.querySelector('[data-gc-tiers]');
		if (tiers) {
			gsap.from(tiers.querySelectorAll('[data-tier]'), {
				y: 40, scale: 0.9, opacity: 0, stagger: 0.12, ease: 'back.out(1.8)',
				scrollTrigger: { trigger: tiers, scroller: scroller, start: 'top 75%' },
			});
		}
	}

	// The page takes its full height at once, so a restored scroll position (reload, back) lands where it was.
	var chapters = story ? gsap.utils.toArray(story.querySelectorAll('[data-chapter]')) : [];
	if (chapters.length) {
		story.classList.add('gc-stage');
		story.parentElement.style.height = (chapters.length + 1) * 100 + 'svh';
	}

	// The scroll scenes wait until the browser is idle, so they do not compete with the first paint.
	var wrapper = document.querySelector('.page-wrapper');
	var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 200); };
	idle(function () {
		var media = gsap.matchMedia();
		media.add('(min-width: 990px)', function () { scrolling(wrapper); });
		media.add('(max-width: 989px)', function () { scrolling(window); });
	}, { timeout: 1500 });

	// Sections below load images late: pinned distances must follow the final layout.
	window.addEventListener('load', function () {
		if (story) story.classList.add('gc-story--ready');
		ScrollTrigger.refresh();
	});
})();
